import { render, staticRenderFns } from "./trsCategoryTree.vue?vue&type=template&id=0c726b39"
import script from "./trsCategoryTree.vue?vue&type=script&lang=js"
export * from "./trsCategoryTree.vue?vue&type=script&lang=js"
import style0 from "./trsCategoryTree.vue?vue&type=style&index=0&id=0c726b39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports